var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveWhiteArrowRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5C1.225 9.5 0.9895 9.40217 0.7935 9.2065C0.597833 9.0105 0.5 8.775 0.5 8.5V2.25C0.5 2.125 0.520833 2.0125 0.5625 1.9125C0.604167 1.8125 0.658333 1.71667 0.725 1.625L1.425 0.775C1.49167 0.683333 1.575 0.6145 1.675 0.5685C1.775 0.522833 1.88333 0.5 2 0.5H8C8.11667 0.5 8.225 0.522833 8.325 0.5685C8.425 0.6145 8.50833 0.683333 8.575 0.775L9.275 1.625C9.34167 1.71667 9.39583 1.8125 9.4375 1.9125C9.47917 2.0125 9.5 2.125 9.5 2.25V8.5C9.5 8.775 9.40217 9.0105 9.2065 9.2065C9.0105 9.40217 8.775 9.5 8.5 9.5H1.5ZM1.7 2H8.3L7.875 1.5H2.125L1.7 2ZM5 8L7 6L6.3 5.3L5.5 6.1V4H4.5V6.1L3.7 5.3L3 6L5 8Z",
    fill: "#D11E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveWhiteArrowRed);
export default __webpack_public_path__ + "static/media/archive_white_arrow_red.409cd0ad365c0b851841792ffdc27ebd.svg";
export { ForwardRef as ReactComponent };